<div class="padd-0-25 marg-t-70">
    <nav aria-label="breadcrumb ">
        <ol class="breadcrumb fsize27 padd_0 ">
            <li class="breadcrumb-item"><a [routerLinkActive]="['active']" (click)="isShown = false"
                    [routerLink]="['/workout-edit']">Back</a></li>
            <li class="breadcrumb-item active font_bold_gilroy" aria-current="page">Question Workout Edit</li>
        </ol>
    </nav>

    <div class="marg-t-40">
        <div class="row marg-0">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <form>

                    <!-- <div class="form-group">
                        <label class="fsize16 clr_black font_bold_gilroy">Title</label>
                        <input type="text" disabled [(ngModel)]="workoutTitle" [ngModelOptions]="{standalone: true}"
                            id="questions" class="form-control input_bdr_clr font_text " />
                    </div> -->


                    <div class="form-group">
                        <label class="fsize16 clr_black font_bold_gilroy">Question type *</label>
                        <!-- <input type="text" [(ngModel)]="questiontypeEdit" [ngModelOptions]="{standalone: true}"
                            class="form-control input_bdr_clr font_text" /> -->

                        <select (change)="questionType_One()" id="workoutQuestionType" [(ngModel)]="questiontypeEdit"
                            [ngModelOptions]="{standalone: true}"
                            class=" form-control input_bdr_clr ">
                            <option selected disabled val="">Select Question type</option>
                            <option value="text">Text</option>
                            <option value="mind dump">Mind dump</option>

                        </select>

                    </div>

                    <div class="form-group" *ngIf="questionType_Text_question">
                        <label class="fsize16 clr_black font_bold_gilroy">Question *</label>
                        <!-- <input type="text" [(ngModel)]="questionEdit" [ngModelOptions]="{standalone: true}"
                            id="questions" class="form-control input_bdr_clr font_text " /> -->

                            <ckeditor 
                            name="myckeditor"
                            [(ngModel)]="questionEdit" [ngModelOptions]="{standalone: true}"
                          
                            debounce="500" 
                    >
                  </ckeditor>  
                            


                    </div>



                    <div class="form-group" *ngIf="type_Text_placeholder">
                        <label class="fsize16 clr_black font_bold_gilroy">Placeholder text *</label>
                        <!-- <input type="text" [(ngModel)]="placeholder_Text" [ngModelOptions]="{standalone: true}"
                            class="form-control input_bdr_clr font_text" /> -->
                      
                            <ckeditor 
                            name="myckeditor"
                            [(ngModel)]="placeholder_Text" [ngModelOptions]="{standalone: true}"
                          
                            debounce="500" 
                    >
                  </ckeditor>  


                    </div>


                    <div *ngIf="type_Text_placeholder">
                        <span class="fsize16 clr_black font_bold_gilroy">Show Feeling * :
                        </span>
                        <span>
                            <label for="vehicle1"> Yes</label>
                            <input class="marg-l-8" type="radio" 
                                name="vehicle1" value="1"
                                [(ngModel)]="show_FeelingRadioBtn" [ngModelOptions]="{standalone: true}"
                                >
                        </span>

                        <span>
                            <label class="marg-l-8" for="vehicle1"> No</label>
                            <input class="marg-l-8" type="radio" 
                                name="vehicle1" value="0"
                                [(ngModel)]="show_FeelingRadioBtn" [ngModelOptions]="{standalone: true}"
                                >
                        </span>
                    </div>



                    <div class="form-group" *ngIf="position_questionType_Text">
                        <label class="fsize16 clr_black font_bold_gilroy">Position *</label>
                        <input type="text" class="form-control input_bdr_clr font_text" [(ngModel)]="positionEdit"
                            [ngModelOptions]="{standalone: true}" />
                    </div>

                    <div class="form-group marg-t-40">
                        <button type="submit" class="btn  submit_btn_clr" (click)="questionSubmit()">Submit</button>
                    </div>

                </form>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
            </div>
        </div>
    </div>
</div>